import React, { useState } from 'react';
import { Modal } from '@curo/curo-design-system';
import { FeedbackFloat } from '../../element';
import { ModalContent } from '../../element/StyledGrommetElem';
import Strings from '../../../locales/Strings';

const Feedback = () => {
  const [showModal, setShowModal] = useState(false);

  const handleFeedbackClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <FeedbackFloat data-test-id="feedback-float" onClick={handleFeedbackClick}>
        Feedback
      </FeedbackFloat>
      {showModal && (
        <Modal
          dataTestId="feedback-modal"
          a11yTitle="Feedback Modal"
          title={Strings.sendFeedback}
          closeAction={handleCloseModal}>
          <ModalContent>
            <p>{Strings.sendFeedbackDesc}</p>
            <p>
              {Strings.plsSendEmail}
              <a href="mailto:feedback.welcome.center@hpe.com" data-test-id="email-link">
                feedback.welcome.center@hpe.com
              </a>
              .
            </p>
            <p>
              {Strings.reachTechnicalSupport}
              <a
                href="https://www.hpe.com/us/en/collaterals/collateral.a00039121enw.html"
                target="_blank"
                rel="noopener noreferrer">
                Technical Support Phone Numbers
              </a>
              .
            </p>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Feedback;
